"use client";

import React, { useState } from "react";
import Link from "next/link";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
import LogoAnimado from "./LogoAnimada";

export default function Navmenu({ menu, config }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleSubmenu = (slug) =>
    setOpenSubmenu(openSubmenu === slug ? null : slug);

  return (
    <header className="fixed bg-white h-[80px] lg:h-[120px] w-full flex items-center shadow-md z-50">
      <div className="w-full h-[20px] bg-brand-blue fixed top-0 left-0 z-50" />

      <div className="w-full max-w-[1440px] mx-auto px-4 pt-5 flex justify-between items-center">

        {/* Wrapper logo + hamburger */}
        <div className="flex justify-between items-center w-full lg:w-auto">

          {/* Logo Desktop (fixo grande) */}
          <div className="hidden lg:flex flex-shrink-0">
            <Link href="/">
              <div className="cursor-pointer w-[400px] h-[80px] flex justify-center items-center">
                <LogoAnimado />
              </div>
            </Link>
          </div>

          {/* Logo Mobile (responsivo) */}
          <div className="flex lg:hidden flex-shrink-0">
            <Link href="/">
              <div className="cursor-pointer w-[80%] max-w-[60%] h-[80px] flex justify-center items-center">
                <LogoAnimado />
              </div>
            </Link>
          </div>

          {/* Hamburger mobile */}
          <div className="lg:hidden ml-auto text-3xl text-brand-blue" onClick={toggleMenu}>
            {menuOpen ? <FiX /> : <FiMenu />}
          </div>
        </div>

        {/* Menu */}
        <nav
          className={`
            absolute lg:static
            top-[80px] left-0
            w-full lg:w-auto
            bg-white
            lg:bg-transparent
            transition-all duration-300 ease-in-out
            ${menuOpen ? "block" : "hidden"} lg:block
          `}
        >
          <ul
            className={`
              flex flex-col lg:flex-row lg:items-center lg:space-x-8 font-medium px-4 lg:px-0 py-4 lg:py-0
              text-brand-blue
            `}
          >
            {(menu || []).map((item, index) => (
              <React.Fragment key={index}>
                {item.submenu.length === 0 ? (
                  <li className="pb-4 lg:pb-0">
                    <Link
                      href={item.target}
                      className="relative group"
                      target={item.external ? "_blank" : ""}
                      onClick={() => setMenuOpen(false)}
                    >
                      {item.label}
                      <span className="absolute -bottom-1 left-0 right-0 h-1 rounded-full bg-brand-steel scale-x-0 origin-left transition-transform group-hover:scale-x-100"></span>
                    </Link>
                  </li>
                ) : (
                  <li className="relative pb-4 lg:pb-0">
                    <div className="flex items-center justify-between group">
                      <Link
                        href={item.target}
                        className="relative group"
                        onClick={() => {
                          setMenuOpen(false);
                          setOpenSubmenu(null);
                        }}
                      >
                        {item.label}
                        <span className="absolute -bottom-1 left-0 right-0 h-1 rounded-full bg-brand-steel scale-x-0 origin-left transition-transform group-hover:scale-x-100"></span>
                      </Link>
                      <button
                        onClick={() => toggleSubmenu(item.slug)}
                        className="ml-2"
                        aria-label={`Abrir submenu ${item.label}`}
                        type="button"
                      >
                        <FiChevronDown
                          className={`transition-transform duration-300 text-brand-blue ${
                            openSubmenu === item.slug ? "rotate-180" : "rotate-0"
                          }`}
                        />
                      </button>
                    </div>
                    <ul
                      className={`
                        lg:absolute lg:bg-white lg:text-brand-blue
                        lg:mt-2 lg:py-2 lg:w-64
                        shadow-lg rounded-md space-y-1
                        ${openSubmenu === item.slug ? "block" : "hidden"}
                      `}
                    >
                      {item.submenu.map((subitem, subindex) => (
                        <li key={subindex}>
                          <Link
                            href={subitem.target}
                            target={item.external ? "_blank" : ""}
                            className="block px-4 py-2 hover:bg-brand-steel hover:text-white relative group transition text-brand-blue"
                            onClick={() => {
                              setMenuOpen(false);
                              setOpenSubmenu(null);
                            }}
                          >
                            {subitem.label}
                            <span className="absolute -bottom-1 left-0 right-0 h-1 rounded-full bg-brand-steel scale-x-0 origin-left transition-transform group-hover:scale-x-100"></span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                )}

                {/* Ícones sociais */}
                {index + 1 >= menu.length && config.configSocial && (
                  <li key={index + 200} className="flex space-x-4 mt-4 lg:mt-0">
                    {config.configSocial.map((social, k) => (
                      <a
                        href={social.profile}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={k}
                        className="group"
                      >
                        {social.unit === "F" && (
                          <FaFacebook className="text-brand-blue group-hover:text-[#1877F2] transition-colors duration-200" />
                        )}
                        {social.unit === "I" && (
                          <FaInstagram className="text-brand-blue group-hover:text-[#E1306C] transition-colors duration-200" />
                        )}
                      </a>
                    ))}
                  </li>
                )}
              </React.Fragment>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
